
import { component } from '@/helpers/vueTyped';
import router from '@/router';
import store, { dispatch } from '@/store';

export default component()({
  name: 'BackButton',

  render() {
    return (
      <div v-spatial-container v-spatial-element='back-button' onClick={routeBack} class='back-button-container'>
        <div class='back-button-BB'>
          <img class='left-arrow' src='/svg/left-arrow.svg' />
          <div class='back-button-text'>{'Back'}</div>
        </div>
      </div>
    );
  },
});

export const routeBack = (): void => {
  dispatch('popNavigationContext');

  const context = store.state.navigationContext;

  if (context) {
    router.push(context.route.path);
  } else {
    router.push('/');
  }
};

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3ca41a58/BackButton.vue" });